import { useSelector, useDispatch } from 'react-redux';
import { SELECT_APP } from './REDUX/actions';
import { navigate } from 'hookrouter';
import { USE_ROUTER } from './config';

const useGoHome = () => {
  const dispatch = useDispatch();
  const { common } = useSelector(state => state);
  const { singleApp, beenHome } = common;

  if (singleApp) {
    return null;
  }

  return () => {
    if (beenHome) {
      window.history.back();
    } else if (USE_ROUTER) {
      navigate('/', true);
    } else {
      dispatch({ type: SELECT_APP, app: null });
    }
  };
};

export default useGoHome;
